import React, { Component } from 'react';

import './ContactButton.css';
import ContactModal from './ContactModal';

class ContactButton extends Component {

    constructor(props) {
        super(props);

        this.modal = null;
        this.state = {
            showModal: this.props.showModal
        };
    }

    setModal(modal) {
        this.modal = modal;
    }

    openModal() {
        this.modal.open();
    }

    closeModal() {
        this.modal.close();
    }

    render() {
        return (
            <button className="btn btn-contact" type="button" onClick={this.openModal.bind(this)}>
                <span className="glyphicon glyphicon-envelope" />

                <ContactModal onSubmit={this.closeModal.bind(this)} ref={this.setModal.bind(this)} />
            </button>
        );
    }

}

export default ContactButton;



// WEBPACK FOOTER //
// ./src/components/contact/ContactButton.js